const page = require("../../../../../components/page/page");
const handler = require("./reportHub-report-handler");

import reportHubPage from "./reportHub-page.html";

var HTMLwasSelected = false;

function HTMLselect() {
  HTMLwasSelected = true;
  const body = document.body;
  body.insertAdjacentHTML("beforeend", reportHubPage);
}

export function start(detail) {
  if (!HTMLwasSelected) {
    HTMLselect();
  }
  obj[detail.act].start(detail);
}

const obj = {
  show: {
    start: (detail) => {
      page.start(detail);
      handler.initFilters();
    },
  },
  selectReport: {
    start: (detail) => {
      selectReport(detail);
    },
  },
}

function selectReport(detail) {
  switch (detail.by) {
    case "selectReport":
      handler.onSelectReport(detail);
      break;
    case "runFilteredReport":
      handler.onRunFilteredReport(detail);
      break;
    case "cleanAll":
      handler.onCleanAll();
      break;
    case "toggleSendEmail":
      handler.onToggleSendEmail();
      break;
    case "selectedEntityEmail":
      handler.onSelectedEntityEmail(detail);
      break;
    case "sendReportEmail":
      handler.onSendReportEmail();
      break;
    default:
      break;
  }
}
